import { render } from "./DatasetProgressList.vue?vue&type=template&id=5049388e"
import script from "./DatasetProgressList.vue?vue&type=script&lang=js"
export * from "./DatasetProgressList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__